import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner, makeStyles } from '@fluentui/react-components';
import { usePortalAuth } from '../contexts/PortalAuthContext';

const useStyles = makeStyles({
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
});

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const styles = useStyles();
  const { isAuthenticated, isLoading } = usePortalAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Spinner size="large" label="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
